import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertService } from './services/alert.service';
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [AlertService],
})
export class AlertModule { }
